import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionsSubject, Store } from '@ngrx/store';
import { PermissionDialog, PtEntity, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import {
  AiAssessmentsService,
  AppAssessmentsService,
  CovidAssessmentsService,
  DataBreachProcessService,
  GlobalMeasureChecksService,
  TreatmentService
} from '@pt/api-client';
import { TreatAction } from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/TreatAction';
import { DocAccess } from 'it/primatoo/openapi/api/org/schemas/common/DocAccess';
import { DataBreachAction } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/DataBreachAction';
import {
  GetAiAsPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/aiassessmentdoc/GetAiAsPermissionResponse';
import {
  GetAppAsPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/appassessmentdoc/GetAppAsPermissionResponse';
import {
  GetCovidAsPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/covidassessmentdoc/GetCovidAsPermissionResponse';
import {
  GetTreatPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/GetTreatPermissionResponse';
import {
  GetDataBreachPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/GetDataBreachPermissionResponse';
import {
  UpdateAiAsPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/aiassessmentdoc/UpdateAiAsPermissionRequest';

import {
  UserPermission as UpdateAppAssUserPermission
} from 'it/primatoo/openapi/api/org/schemas/appassessmentdoc/updateappaspermissionrequest/UserPermission';
import {
  UserGroupPermission as UpdateAppAssUserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/appassessmentdoc/updateappaspermissionrequest/UserGroupPermission';

import {
  UserGroupPermission as UpdateAiAssUserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/aiassessmentdoc/updateaiaspermissionrequest/UserGroupPermission';
import {
  UserPermission as UpdateAiAssUserPermission
} from 'it/primatoo/openapi/api/org/schemas/aiassessmentdoc/updateaiaspermissionrequest/UserPermission';
import {
  UpdateAppAsPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/appassessmentdoc/UpdateAppAsPermissionRequest';
import {
  UpdateCovidAsPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/covidassessmentdoc/UpdateCovidAsPermissionRequest';
import {
  UserPermission as UpdateCovidUserPermission
} from 'it/primatoo/openapi/api/org/schemas/covidassessmentdoc/updatecovidaspermissionrequest/UserPermission';
import {
  UserGroupPermission as UpdateCovidUserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/covidassessmentdoc/updatecovidaspermissionrequest/UserGroupPermission';
import {
  UpdateTreatPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/UpdateTreatPermissionRequest';
import {
  UserPermission as UpdateTreatUserPermission
} from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/updatetreatpermissionrequest/UserPermission';
import {
  UserGroupPermission as UpdateTreatUserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/updatetreatpermissionrequest/UserGroupPermission';
import {
  UpdateDataBreachPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/UpdateDataBreachPermissionRequest';
import {
  UserPermission as UpdateDataBreachUserPermission
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/updatedatabreachpermissionrequest/UserPermission';
import {
  UserGroupPermission as UpdateDataBreachUserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/updatedatabreachpermissionrequest/UserGroupPermission';
import { AiAsAction } from 'it/primatoo/openapi/api/org/schemas/aiassessmentdoc/AiAsAction';
import { AppAsAction } from 'it/primatoo/openapi/api/org/schemas/appassessmentdoc/AppAsAction';
import { CovidAsAction } from 'it/primatoo/openapi/api/org/schemas/covidassessmentdoc/CovidAsAction';
import {
  GetGlobalMeasCheckPermissionResponse
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/GetGlobalMeasCheckPermissionResponse';
import {
  UpdateGlobalMeasCheckPermissionRequest
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/UpdateGlobalMeasCheckPermissionRequest';
import {
  GlobalMeasureCheckAction
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/GlobalMeasureCheckAction';
import {
  UserPermission
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/updateglobalmeascheckpermissionrequest/UserPermission';
import {
  UserGroupPermission
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/updateglobalmeascheckpermissionrequest/UserGroupPermission';
import { PtCoreSelectors } from '@pt/pt-core';
import { LoginResponse } from 'it/primatoo/openapi/api/adm/schemas/login/LoginResponse';
import { PrimatooModule } from 'it/primatoo/openapi/api/org/schemas/common/PrimatooModule';
import {
  DocumentPermissionData
} from '../../documents/components/input-document-permission-selector/document-permission-data';
import { DocumentPermissionDataUtils} from '../../documents/components/input-document-permission-selector/document-permission-data-utils';
import { ValidatorGenerator } from '../../documents/utils/validator-generator';


@Component({
  selector: 'pt-permission-dialog',
  templateUrl: './permission-dialog.component.html'
})
export class PermissionDialogComponent implements OnDestroy {
  public permissionDialog: PermissionDialog;
  public loading = false;
  public formGroup: FormGroup;
  public REQUIRED = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public activePermission: DocumentPermissionData[];
  public actionValue: string[] = [];
  public accessValue: string[] = [];
  public loadingSave = false;
  public editable = false;
  public loginResponse$: Observable<LoginResponse> = this.store.select(PtCoreSelectors.loginResponse);
  public activeModules$: Observable<PrimatooModule[]> = this.store.select(PtCoreSelectors.activeModules);

  private destroy$ = new Subject<boolean>()
  public isAdminOrSystem = false;

  constructor(
    public store: Store,
    public activeModal: NgbActiveModal,
    public actionsSubject: ActionsSubject,
    private treatmentService: TreatmentService,
    private appAssessmentService: AppAssessmentsService,
    private aiAssessmentService: AiAssessmentsService,
    private riskAssessmentService: GlobalMeasureChecksService,
    private covidAssessmentsService: CovidAssessmentsService,
    private dataBreachService: DataBreachProcessService
  ) {
  }

  init(permissionDialog: PermissionDialog) {
    this.permissionDialog = permissionDialog;
    this.initNavigationData();
    this.loadActivePermission();

    this.activeModules$.subscribe((activeModules: PrimatooModule[]) => {
      this.actionValue = this.getDocumentActions(this.permissionDialog.entity, activeModules);
    })
    this.accessValue = Object.keys(DocAccess);


    this.loginResponse$.subscribe((p) => {
      this.isAdminOrSystem = p.system || p.permissions.admin;
    })
  }

  public getDocumentActions(documentType: PtEntity, activeModules: PrimatooModule[]): string[] {
    let response: string[] = [];
    switch (documentType) {
      case 'aiAssessment':
        response = Object.keys(AiAsAction);
        break;
      case 'appAssessment':
        response =  Object.keys(AppAsAction);
        break;
      case 'covidAssessment':
        response =  Object.keys(CovidAsAction);
        break;
      case 'globalMeasureCheck':
        response =  Object.keys(GlobalMeasureCheckAction);
        break;
      case 'treatmentsHolder':
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards':
        response =  Object.keys(TreatAction);
        break;
      case 'dataBreach':
        response =  Object.keys(DataBreachAction)
        break;
    }
    if (!activeModules.includes(PrimatooModule.LIA)) {
      response = response.filter(r => r !== TreatAction.EDIT_CHAPTER_LIA);
    }
    return response;
  }

  save() {
    this.loadingSave = true;
    switch (this.permissionDialog.entity) {
      case 'aiAssessment':
        this.saveAiAssessment();
        break;
      case 'appAssessment':
        this.saveAppAssessment();
        break;
      case 'covidAssessment':
        this.saveCovidAssessment();
        break;
      case 'globalMeasureCheck':
        this.saveGlobalMeasureCheck();
        break;
      case 'treatmentsHolder':
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards':
        this.saveTreatment();
        break;
      case 'dataBreach':
        this.saveDataBreach();
        break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  getFormPermissionValue(): DocumentPermissionData[] {
    return this.formGroup.controls.permissions.value || []
  }

  private loadActivePermission() {
    switch (this.permissionDialog.entity) {
      case 'aiAssessment':
        this.loadAiAssessmentActivePermission(this.permissionDialog.docId);
        break;
      case 'appAssessment':
        this.loadAppAssessmentActivePermission(this.permissionDialog.docId);
        break;
      case 'covidAssessment':
        this.loadCovidAssessmentActivePermission(this.permissionDialog.docId);
        break;
      case 'globalMeasureCheck':
        this.loadRiskAssessmentActivePermission(this.permissionDialog.docId);
        break;
      case 'treatmentsHolder':
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards':
        this.loadTreatmentActivePermission(this.permissionDialog.docId);
        break;
      case 'dataBreach':
        this.loadDataBreachActivePermission(this.permissionDialog.docId);
        break;
    }
  }

  private initNavigationData() {
    this.loading = true;
    this.permissionDialog.entity
    this.initFormGroup();
  }

  private initFormGroup() {
    this.formGroup = new FormGroup({
      permissions: new FormControl([]),
    });
    this.loading = false;
  }

  private setFormGroup(activePermission: DocumentPermissionData[]) {
    this.formGroup.controls.permissions.setValue(activePermission || []);
    this.formGroup.markAsUntouched();
  }

  private closeDialog(close: boolean) {
    this.loadingSave = false;
    if (close) {
      this.activeModal.close(close);
    }
  }

  private saveAiAssessment() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateAiAsPermissionRequest = {
      users: formRawValue?.filter((f) => f.type === 'USER').map(m => {
        const item: UpdateAiAssUserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as AiAsAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue?.filter((f) => f.type === 'GROUP').map(m => {
        const item: UpdateAiAssUserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as AiAsAction[] || []
        };
        return item;
      }) || []
    }
    this.aiAssessmentService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      }, error: () => {
        this.closeDialog(false);
      }
    });
  }

  private saveAppAssessment() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateAppAsPermissionRequest = {
      users: formRawValue.filter((f) => f.type === 'USER').map(m => {
        const item: UpdateAppAssUserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as AppAsAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue.filter((f) => f.type === 'GROUP').map(m => {
        const item: UpdateAppAssUserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as AppAsAction[] || []
        };
        return item;
      }) || []
    }
    this.appAssessmentService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      }, error: () => {
        this.closeDialog(false);
      }
    });
  }

  private saveCovidAssessment() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateCovidAsPermissionRequest = {
      users: formRawValue.filter((f) => f.type === 'USER').map(m => {
        const item: UpdateCovidUserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as CovidAsAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue.filter((f) => f.type === 'GROUP').map(m => {
        const item: UpdateCovidUserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as CovidAsAction[] || []
        };
        return item;
      }) || []
    }
    this.covidAssessmentsService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      },
      error: () => {
        this.closeDialog(false);
      }
    });
  }

  private saveGlobalMeasureCheck() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateGlobalMeasCheckPermissionRequest = {
      users: formRawValue.filter((f) => f.type === 'USER').map(m => {
        const item: UserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as GlobalMeasureCheckAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue.filter((f) => f.type === 'GROUP').map(m => {
        const item: UserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as GlobalMeasureCheckAction[] || []
        };
        return item;
      }) || []
    }
    this.riskAssessmentService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      },
      error: () => {
        this.closeDialog(false);
      }
    });
  }

  private saveTreatment() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateTreatPermissionRequest = {
      users: formRawValue.filter((f) => f.type === 'USER').map(m => {
        const item: UpdateTreatUserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as TreatAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue.filter((f) => f.type === 'GROUP').map(m => {
        const item: UpdateTreatUserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as TreatAction[] || []
        };
        return item;
      }) || []
    }
    this.treatmentService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      },
      error: () => {
        this.closeDialog(false);
      }
    });
  }

  private saveDataBreach() {
    const formRawValue: DocumentPermissionData[] = this.getFormPermissionValue();
    const request: UpdateDataBreachPermissionRequest = {
      users: formRawValue.filter((f) => f.type === 'USER').map(m => {
        const item: UpdateDataBreachUserPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as DataBreachAction[] || []
        };
        return item;
      }) || [],
      userGroups: formRawValue.filter((f) => f.type === 'GROUP').map(m => {
        const item: UpdateDataBreachUserGroupPermission = {
          id: m.id,
          access: m.access as DocAccess,
          actions: m.actions as DataBreachAction[] || []
        };
        return item;
      }) || []
    }
    this.dataBreachService.patchActivePermission(this.permissionDialog.docId, request).subscribe({
      next: () => {
        this.closeDialog(true);
      },
      error: () => {
        this.closeDialog(false);
      }
    });
  }

  private loadAiAssessmentActivePermission(docId: number) {
    this.aiAssessmentService.getActivePermission(docId).subscribe({
      next: (success: GetAiAsPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindAiAssessmentPermissionsResponse(
          success);
        this.setFormGroup(this.activePermission)
      }, error: () => {
        this.activePermission = []
        this.setFormGroup(this.activePermission)
      }
    });
    this.checkDocUserPermission(this.aiAssessmentService.getDocUserPermission(docId));
  }

  private checkDocUserPermission(api: Observable<{ access: DocAccess }>) {
    api.subscribe(p => {
      this.editable = p.access === DocAccess.FULL;
      if (this.editable) {
        this.formGroup.enable();
      } else {
        this.formGroup.disable();
      }
    })
  }

  private loadAppAssessmentActivePermission(docId: number) {
    this.appAssessmentService.getActivePermission(docId).subscribe({
      next: (success: GetAppAsPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindAppAssessmentPermissionsResponse(success);
        this.setFormGroup(this.activePermission)
      }, error: () => {
        this.activePermission = []
        this.setFormGroup(this.activePermission)
      }
    });
    this.checkDocUserPermission(this.appAssessmentService.getDocUserPermission(docId));
  }

  private loadRiskAssessmentActivePermission(docId: number) {
    this.riskAssessmentService.getActivePermission(docId).subscribe({
      next: (success: GetGlobalMeasCheckPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindRiskAssessmentPermissionsResponse(success);
        this.setFormGroup(this.activePermission)
      }, error: () => {
        this.activePermission = []
        this.setFormGroup(this.activePermission)
      }
    });
    this.checkDocUserPermission(this.riskAssessmentService.getDocUserPermission(docId));
  }

  private loadCovidAssessmentActivePermission(docId: number) {
    this.covidAssessmentsService.getActivePermission(docId).subscribe({
      next: (success: GetCovidAsPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindCovidAssessmentPermissionsResponse(success);
        this.setFormGroup(this.activePermission);
      }, error: () => {
        this.activePermission = [];
        this.setFormGroup(this.activePermission);
      }
    });
    this.checkDocUserPermission(this.covidAssessmentsService.getDocUserPermission(docId));
  }

  private loadTreatmentActivePermission(docId: number) {
    this.treatmentService.getActivePermission(docId).subscribe({
      next: (success: GetTreatPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindTreatmentPermissionsResponse(success);
        this.setFormGroup(this.activePermission);
      }, error: () => {
        this.activePermission = [];
        this.setFormGroup(this.activePermission);
      }
    });
    this.checkDocUserPermission(this.treatmentService.getDocUserPermission(docId));
  }

  private loadDataBreachActivePermission(docId: number) {
    this.dataBreachService.getActivePermission(docId).subscribe({
      next: (success: GetDataBreachPermissionResponse) => {
        this.activePermission = DocumentPermissionDataUtils.fromFindDataBreachPermissionsResponse(success);
        this.setFormGroup(this.activePermission);
      }, error: () => {
        this.activePermission = [];
        this.setFormGroup(this.activePermission);
      }
    });
    this.checkDocUserPermission(this.dataBreachService.getDocUserPermission(docId));
  }
}
